import React, { useEffect, useState } from 'react';
import Sidebar from './components/Sidebar';
import ChatWindow from './components/ChatWindow';
import NewChatModal from './components/NewChatModal';
import { getConversations, getMessages, deleteSession, getUserId, setUserId } from './api';
import UserIdGate from './components/UserIdGate';

function App() {
  const [currentUserId, setCurrentUserId] = useState(getUserId());
  const [selectedSession, setSelectedSession] = useState({ id: '', isNew: true });
  const [conversations, setConversations] = useState([]);
  const [showNewChat, setShowNewChat] = useState(false);
  const [newMessages, setNewMessages] = useState([]);
  const [selectedModel, setSelectedModel] = useState('Gemini'); // หรือ default เป็น 'claude' ได้

  // 📦 โหลดรายการ conversation ทั้งหมด
 const refreshConversations = async () => {
  try {
    const result = await getConversations(); // result เป็น array แล้ว
    setConversations(result); // ✅ ตรงนี้ต้องส่ง array ตรง ๆ
  } catch (err) {
    console.error('Failed to load conversations', err);
  }
};

  const handleModelChange = (e) => {
    setSelectedModel(e.target.value);
  };
  // 📩 เมื่อเลือก session ที่มีอยู่
  const handleSelectSession = async (sessionId) => {
    setSelectedSession({ id: sessionId, isNew: false });
    const messages = await getMessages(sessionId);
    setNewMessages(messages);
  };
  const handleNewChat = () => {
    setSelectedSession({ id: '', isNew: true }); // ส่ง isNew = true
    setNewMessages([]);
  };

  // ✅ เมื่อสร้าง session ใหม่สำเร็จ (จาก ChatWindow หรือ Modal)
 const handleNewChatCreated = (sessionId, messages) => {
  setSelectedSession({ id: sessionId, isNew: false });
  setNewMessages(messages); // ส่งข้อความแรกไป preload
  refreshConversations();
};
const handleDeleteSession = async (sessionId) => {
  if (window.confirm('Are you sure you want to delete this session?')) {
    try {
      await deleteSession(sessionId);
      await refreshConversations();
      if (selectedSession?.id === sessionId) {
        setSelectedSession(null);
      }
    } catch (err) {
      alert('Failed to delete session.');
    }
  }
};

  useEffect(() => {
    if (currentUserId) {
      refreshConversations();
    }
  }, [currentUserId]);

  if (!currentUserId) {
    return <UserIdGate onSubmit={(userId) => {
      setUserId(userId);
      setCurrentUserId(userId);
    }} />;
  }
  // chat ui เดิม
  return (
    <div className="container-fluid">
      <div className="row">
        <Sidebar
          conversations={conversations}
          onSelectSession={handleSelectSession}
          onNewChat={handleNewChat}
          onRefreshConversations={refreshConversations}
          onDeleteSession={handleDeleteSession}
          selectedModel={selectedModel}
          onModelChange={handleModelChange}
        />
        <ChatWindow
          session={selectedSession}
          preloadMessages={newMessages}
          onSessionCreated={handleNewChatCreated}
          selectedModel={selectedModel}
        />
      </div>
    </div>
  );
}

export default App;
